'use strict';

var ngModule = 'frontend.admin';

require('angular')
  .module(ngModule, [
    require('./users')
  ])
  .component('admin', require('./admin'));

module.exports = ngModule;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/index.js
 ** module id = 138
 ** module chunks = 0
 **/